// audienceActions.js
import * as actions from "./actionsTypes";
import AudiencesActionsServices from "./audiences_actions.service";
import toastr from "toastr";
import messages from "../../messages";
import axios from "axios";

// Configuración de toastr
toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

// Obtiene datos del jefe
export const getDataBoss = (id) => async (dispatch) => {
  try {
    dispatch({ type: actions.LOADING_AUDIENCES_ACTIONS, payload: true });
    const response = await AudiencesActionsServices.getDataBoss(id);
    dispatch({ type: actions.GET_DATA_BOSS, payload: response.data });
  } catch (error) {
    handleError(error, dispatch, actions.AUDIENCES_ACTIONS_FAIL);
  } finally {
    dispatch({ type: actions.LOADING_AUDIENCES_ACTIONS, payload: false });
  }
};

// Limpia el state/jefe
export const resetDataBoss = () => (dispatch) => {
  dispatch({ type: actions.RESET_DATA_BOSS });
};

// Audiencias
export const getAudiences = (filters) => async (dispatch) => {
  try {
    dispatch({ type: actions.LOADING_AUDIENCES_ACTIONS, payload: true });
    const response = await AudiencesActionsServices.getAudiences(filters);
    dispatch({
      type: actions.GET_AUDIENCES_ACTIONS,
      payload: {
        audiencesActions: response.data,
        audiencesActionsLength: response.data.count,
      },
    });
  } catch (error) {
    handleError(error, dispatch, actions.AUDIENCES_ACTIONS_FAIL);
  } finally {
    dispatch({ type: actions.LOADING_AUDIENCES_ACTIONS, payload: false });
  }
};

// Crear una audiencia
export const createAudience = (data) => async (dispatch) => {
  try {
    dispatch({ type: actions.SAVE_LOADING_AUDIENCES_ACTIONS, payload: true });
    const response = await AudiencesActionsServices.createAudience(data);
    dispatch({ type: actions.CREATE_AUDIENCE, payload: response.data });

    // Despachar la acción para obtener las audiencias actualizadas
    await dispatch(getAudiences());
    toastr.success(messages.successMessage);
    
    // Retornar el ID de la audiencia creada
    return response.data.id;

  } catch (error) {
    handleError(error, dispatch, actions.FORM_FAIL);
  } finally {
    dispatch({ type: actions.SAVE_LOADING_AUDIENCES_ACTIONS, payload: false });
  }
};

// Actualizar una audiencia
export const updateAudience = (data, id) => async (dispatch) => {
  try {
    dispatch({ type: actions.LOADING_AUDIENCES_ACTIONS, payload: true });
    const response = await AudiencesActionsServices.updateAudience(data, id);
    dispatch({ type: actions.UPDATE_AUDIENCE, payload: response.data });

    await dispatch(getAudiences());
    toastr.success(messages.successMessage);

  } catch (error) {
    handleError(error, dispatch, actions.FORM_FAIL);
  } finally {
    dispatch({ type: actions.LOADING_AUDIENCES_ACTIONS, payload: false });
  }
};

// Eliminar una audiencia
export const deleteAudience = (id) => async (dispatch) => {
  try {
    dispatch({ type: actions.LOADING_AUDIENCES_ACTIONS, payload: true });
    await AudiencesActionsServices.deleteAudience(id);
    dispatch({ type: actions.DELETE_AUDIENCE, payload: id });

    await dispatch(getAudiences());
    toastr.success(messages.successMessage);
    
  } catch (error) {
    handleError(error, dispatch, actions.AUDIENCES_ACTIONS_FAIL);
  } finally {
    dispatch({ type: actions.LOADING_AUDIENCES_ACTIONS, payload: false });
  }
};

// Enviar correo
export const emailSend = (data,  id) => async (dispatch) => {
  try {
    dispatch({ type: actions.LOADING_EMAIL_SEND, payload: true });
    await AudiencesActionsServices.emailSend(data, id);
    toastr.success(messages.correoEnviado);
  } catch (error) {
    handleError(error, dispatch, actions.EMAIL_ERROR);
  } finally {
    dispatch({ type: actions.LOADING_EMAIL_SEND, payload: false });
  }
};

// Manejo de errores
const handleError = (error, dispatch, actionType) => {
  let message = null;
  if (axios.isAxiosError(error)) {
    if (error.response?.status) {
      switch (error.response.status) {
        case 400:
          message = messages.errorMessage + " " + error.response.statusText;
          break;
        case 404:
          message = messages.errorMessage + " " + error.response.statusText;
          break;
        case 500:
          message = messages.errorMessage + " " + error.response.statusText;
          break;
        default:
          message = error.response.data;
          break;
      }
    } else {
      message =
        error.message === "Network Error"
          ? messages.networkError
          : error.message;
    }
  } else {
    message =
      error.message === "Network Error" ? messages.networkError : error.message;
  }
  dispatch({ type: actionType, payload: message });
};
